import { Link } from "react-router-dom";

import { Button } from "@/components/ui/Button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand">404</p>
      <h1 className="mt-2 font-display text-4xl text-ink">Page not found</h1>
      <p className="mt-3 max-w-md text-sm text-muted">
        That route is not part of the partner portal.
      </p>
      <Link to="/applications" className="mt-6">
        <Button>Go to applications</Button>
      </Link>
    </div>
  );
}
